import { useContext, useEffect, useState } from "react";
import { getLocalStorage } from "global/utils/safeJsonParse";
import { TimerContainer } from "./localStyle";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { PortalContext } from "_+_Portal/context/Provider";
import { hideSegundoModal, showSegundoModal } from "_+_Portal/context/Actions/segundoModal/segundoModal";

const TimerAT = ({ currentTime, timerGlobal, flgTimerGlobal }) => {
  const { segundoModalDispatch } = useContext(PortalContext);

  const [active, setActive] = useState(false);
  const [time, setTime] = useState(currentTime);
  const [idInterval, setIdInterval] = useState(null);

  const config = getLocalStorage("config", {});
  let isDev = config?.isDev;

  const loop = () => {
    let newTime = time;
    let interval = setInterval(() => {
      if (newTime > 0) {
        newTime = newTime - 1;
        setTime(newTime);
        if (flgTimerGlobal) {
          timerGlobal(newTime);
        }
      } else {
        if (flgTimerGlobal) {
          timerGlobal(currentTime);
        }
        clearInterval(interval);
        setTime(currentTime);
        intervalQuestions();
      }
    }, 1000);
    return interval;
  };

  useEffect(() => {
    let idIntervalReturn;
    if (!isDev) {
      if (currentTime >= 0) {
        if (time > 0 && !active) {
          idIntervalReturn = loop();
          setActive(true);
        }
      }
      return () => {
        if (idInterval) {
          clearInterval(idInterval);
        } else {
          clearInterval(idIntervalReturn);
        }
      };
    }
  }, [idInterval]);

  const intervalQuestions = () => {
    let dissmiss = () => {
      hideSegundoModal()(segundoModalDispatch);
      const idInterval = loop();
      setIdInterval(idInterval);
    };
    showSegundoModal(
      "Genericos/ModalConsultaSalida/ModalConsultaSalida",
      {
        loop: loop,
        setNewInterval: setIdInterval
      },
      [],
      "centro2",
      true
    )(segundoModalDispatch);

    // showModal(
    //   <ModalConsultaSalida loop={loop} setNewInterval={setIdInterval} />,
    //   title,
    //   dissmiss,
    //   false,
    //   {},
    //   "centro",
    //   true
    // )(modalDispatch);
  };

  const formatTime = (seconds) => {
    if (seconds > 60) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = (seconds % 60).toString().padStart(2, "0");
      return (
        <span>
          <span className="timer-number-minutes">
            {minutes}:
            <span className="timer-number-remainingSeconds">
              {remainingSeconds}
            </span>
          </span>{" "}
          minutos
        </span>
      );
    } else {
      return (
        <span>
          <span className="timer-number-seconds">{seconds}</span> segundos
        </span>
      );
    }
  };

  return currentTime > 0 ? (
    <TimerContainer>Le quedan {formatTime(time)} en esta página.</TimerContainer>
  ) : (
    ""
  );
};

export default TimerAT;
